import React from "react";

import Login from "../../Components/UserComponents/Login.jsx";

const LoginPage = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
